import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            lower: 0,
            upper: 11,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 11,
            upper: 21,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 21,
            upper: 40,
          },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
